// src/App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { auth } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import LoginPage from "./components/LoginPage";
import HomePage from "./components/HomePage";
import AddClientPage from "./components/AddClientPage";
import EditClientPage from "./components/EditClientPage";
import ViewClientPage from "./components/ViewClientPage";
import Header from "./components/Header";
import Footer from "./components/Footer";
import "./styles/App.css";

// API Base URL
const API_URL = "https://tour.tiktecho.com/api";

// API Routes
const API_ROUTES = {
  getClients: `${API_URL}/get_clients.php`,
  getClient: (id) => `${API_URL}/get_client.php?id=${id}`,
  createClient: `${API_URL}/add_client.php`,
  editClient: `${API_URL}/edit_client.php`,
  deleteClient: (id) => `${API_URL}/delete_client.php?id=${id}`,
  uploadFile: `${API_URL}/upload.php`
};

function App() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  return (
    <Router basename="/">
      <Header user={user} />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/" element={user ? <HomePage apiRoutes={API_ROUTES} /> : <Navigate to="/login" />} />
        <Route path="/add" element={user ? <AddClientPage apiRoutes={API_ROUTES} /> : <Navigate to="/login" />} />
        <Route path="/edit/:id" element={user ? <EditClientPage apiRoutes={API_ROUTES} /> : <Navigate to="/login" />} />
        <Route path="/view/:id" element={user ? <ViewClientPage apiRoutes={API_ROUTES} /> : <Navigate to="/login" />} />
        <Route path="*" element={<h2>404 - Page Not Found</h2>} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;